// extracted by mini-css-extract-plugin
export default {"search":"style_search__7OLJz","ant-input-affix-wrapper-focused":"style_ant-input-affix-wrapper-focused__SYx2r"};